export default __webpack_public_path__ + "static/media/040_tunnel.last.c77b0580.webp";